module.exports = __webpack_public_path__ + "img/favourites-img.9ca2825c.png";